import { LocationDescriptor } from 'history';
import React, { ComponentPropsWithoutRef } from 'react';
import { Link } from 'react-router-dom';
import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font } from '../theme/base/mixins';
import { StyledAnchorComponent } from '../types';
import { Icon } from './Icon';
import { Image } from './Image';

interface AnkerProps {}

type AnkerPropsThemed = AnkerProps & ThemeProps<Theme>;

export const Anker: StyledAnchorComponent<AnkerProps> = styled.a.attrs({
  rel: ({ target, rel = '' }) =>
    target === '_blank' ? [rel, 'noopener', 'noreferrer'].join(' ') : rel
})`
  ${font(1.8, 2.4, 'bold')};

  text-decoration: ${(props: AnkerPropsThemed) =>
    props.theme.defaults.textDecoration};
  color: ${props => props.theme.colors.secondary};
  transition: all 0.2s;
  &[href] {
    cursor: pointer;
  }

  &[href]:hover {
    color: ${(props: AnkerPropsThemed) => props.theme.colors.primary};

    ${Image} {
      border-color: ${(props: AnkerPropsThemed) => props.theme.colors.primary};
    }

    ${Icon} svg {
      fill: ${(props: AnkerPropsThemed) => props.theme.colors.primary};
    }
  }
`;

// #41041
// deleted module `components/behavior/Download`
// moved component `Download` into this module
// issue probably was cyclic import
// (`Link.tsx` imported `Download.tsx` which imported `Link.tsx` by itself)
type DownloadProps = ComponentPropsWithoutRef<typeof Anker> & {};

const Download = (props: DownloadProps) => (
  <Anker {...props} target="_blank" rel="noopener noreferrer" />
);

type TextLinkProps = ComponentPropsWithoutRef<'a'> & {
  to: LocationDescriptor;
};

const TextLink = (props: TextLinkProps) => {
  const { href = '' } = props;
  const mailto = /^mailto:/gi.test(href);
  const download = /\/(fileadmin|uploads|typo3temp)\//gi.test(href);

  if (props.target === '_blank' || mailto || href.startsWith('#uc-')) {
    return <Anker {...props} />;
  } else if (download) {
    return <Download {...props} />;
  } else {
    return <Link {...props} />;
  }
};

const StyledTextLink: StyledAnchorComponent<
  AnkerProps & TextLinkProps
> = Anker.withComponent(TextLink);

export { StyledTextLink as TextLink };
